import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=2eae2bfe&"
import script from "./Character.vue?vue&type=script&lang=js&"
export * from "./Character.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports